module.exports = __webpack_public_path__ + "static/media/shirts11.03d86121.jpg";